import { MdClose } from "react-icons/md";

export const ViewPaymentModal = ({ setViewModal, userDetail ,openviewModal}) => {
  const { amt, orderId, paymentId, paymentSource , invoiceNo , planName , quentity , PlanPrice } = userDetail || {};

  // console.log(userDetail,"userDetail");
  // console.log(amt, orderId, paymentId, paymentSource , invoiceNo , planName , quentity , PlanPrice,"userDetail");
  
  return (
    <>
    
    {openviewModal && (
          <div
            className="fixed inset-0 z-40 transition-opacity duration-300 bg-black bg-opacity-25"
            onClick={() => setViewModal(false)}
          />
        )}
    <div
        className={`fixed right-0 top-0 h-full w-[500px] bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
          openviewModal ? "translate-x-0" : "translate-x-full"
        } flex flex-col`}
      >
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-2 border-b border-gray-200 bg-[#FCDD00]">
          <div className="flex items-center">
          <h2 className="my-[7px] text-xl font-semibold text-gray-900">Payment Details</h2>
          </div>
          <button onClick={() => setViewModal(false)} className="text-gray-500 hover:text-black">
            <MdClose className="text-2xl" />
          </button>
        </div>

        {/* Payment Info */}
        <div className="flex-1 p-6 space-y-6 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 hover:scrollbar-thumb-gray-400">
          <div className="space-y-4 text-sm text-gray-700">
            <div className="flex justify-between">
              <span className="font-medium text-gray-600">Plan Name:</span>
              <span className="text-gray-900 ">{planName }</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium text-gray-600">Qty:</span>
              <span className="text-gray-900 ">{quentity}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium text-gray-600">Plan Price:</span>
              <span className="text-gray-900 ">₹{PlanPrice}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium text-gray-600">Total Amount:</span>
              <span className="font-semibold text-gray-900">₹{amt}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium text-gray-600">Order ID:</span>
              <span className="text-gray-900">{orderId}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium text-gray-600">Payment ID:</span>
              <span className="text-gray-900">{paymentId}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium text-gray-600">Invoice No:</span>
              <span className="text-gray-900">{invoiceNo}</span>
            </div>
            <div className="flex justify-between">
              <span className="font-medium text-gray-600">Payment Source:</span>
              <span className="text-gray-900 capitalize">{paymentSource}</span>
            </div>
          </div>
        </div>
        {/* Close Button */}
        <div className="flex flex-row gap-3 p-6 border-t border-gray-200 bg-gray-50">
            <button
            onClick={() => setViewModal(false)}
            className="flex items-center justify-center w-full px-4 py-3 font-medium text-gray-700 transition-colors duration-200 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
          >
            Close
          </button>
        </div>
    </div>
    </>
  );
};
